"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_js_1 = require("@attensi/api-js");
var redirectHandler_1 = __importDefault(require("./redirectHandler"));
var AttensiLoginPlugin = /** @class */ (function (_super) {
    __extends(AttensiLoginPlugin, _super);
    function AttensiLoginPlugin(options) {
        var _this = _super.call(this, options) || this;
        _this.authenticationPassed = false;
        _this.debug = false;
        _this.options = options;
        _this.debug = options.debug || _this.debug;
        _this.redirectHandler = new redirectHandler_1.default(_this, options);
        if (options.beforeHook) {
            options.beforeHook({
                subdomain: _this.redirectHandler.subdomain,
                environment: _this.redirectHandler.environment,
                apiToken: _this.redirectHandler.apiToken,
                accessToken: _this.redirectHandler.accessToken,
            });
        }
        _this.created();
        return _this;
    }
    Object.defineProperty(AttensiLoginPlugin.prototype, "isAuthenticated", {
        get: function () {
            return this.authenticationPassed;
        },
        enumerable: true,
        configurable: true
    });
    AttensiLoginPlugin.prototype.logout = function () {
        this.redirectHandler.redirectToLogout();
    };
    AttensiLoginPlugin.prototype.login = function () {
        this.redirectHandler.redirectToLogin();
    };
    AttensiLoginPlugin.prototype.redirectToUrl = function (url) {
        this.redirectHandler.redirectToUrl(url);
    };
    AttensiLoginPlugin.prototype.redirectTo = function (name) {
        this.redirectHandler.redirectToAttensiProduct(name);
    };
    AttensiLoginPlugin.prototype.checkAuthentication = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log("Checking authentication");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.checkAccessToken()];
                    case 2:
                        user = _a.sent();
                        return [4 /*yield*/, this.checkPrivacyAccepted(user)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        if (this.options.autoLogin) {
                            this.login();
                        }
                        throw Error("Authentication failed: " + error_1.message);
                    case 5:
                        this.log("Authentication passed");
                        this.authenticationPassed = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    AttensiLoginPlugin.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.options.checkAuth) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.checkAuthentication()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.options.afterHook) {
                            this.options.afterHook({
                                subdomain: this.redirectHandler.subdomain,
                                environment: this.redirectHandler.environment,
                                apiToken: this.redirectHandler.apiToken,
                                accessToken: this.redirectHandler.accessToken,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AttensiLoginPlugin.prototype.checkAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.portal.getUsersMe().then(function (resp) { return resp.data; })];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, user];
                }
            });
        });
    };
    AttensiLoginPlugin.prototype.checkPrivacyAccepted = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (user.required_onboarding_steps.some(function (step) { return step === 'privacy'; })) {
                    throw Error('User is not onboarded in privacy.');
                }
                return [2 /*return*/];
            });
        });
    };
    AttensiLoginPlugin.prototype.log = function (message) {
        if (this.debug) {
            // tslint:disable-next-line:no-console
            console.log("[ATTENSI-LOGIN-VUE]: " + message);
        }
    };
    return AttensiLoginPlugin;
}(api_js_1.AttensiAPI));
exports.AttensiLoginPlugin = AttensiLoginPlugin;
